import { FC } from "react"
import moment from "moment"
import { getApiUrl } from "../../../utils/getApiUrl"
import AttachmentItemChat from "./assets/AttachmentItemChat"
import { urlify } from "../../../utils/urlify"
import { IChatMessage } from "../../../types/chat"
import { GetUserAvatar } from "../../Assets/GetUserAvatar/GetUserAvatar"
import ChatReply from "../../Chat/ChatReply/ChatReply"
import clsx from "clsx"
import styles from "./ChatModal.module.scss"
import { cleanHtml } from "../../../utils/cleanHTML"
import { useTranslation } from "react-i18next"

interface Props {
  messages: IChatMessage[]
  message: IChatMessage
  nowUserId: string
  projectID: string
  openPhoto?: any // ф-я открытия фото
  contextMenuOpen: (e: any, el: any) => void
}

const ChatMessage: FC<Props> = ({
  messages,
  message,
  nowUserId,
  openPhoto = () => null,
  contextMenuOpen,
  projectID,
}) => {
  const { t } = useTranslation("translation", { keyPrefix: `interface` })

  const itsMe = message?.user?.id === nowUserId

  return (
    <div
      className={clsx("chatMessage", styles.chatMessage, itsMe && styles.chatMessage_my)}
      data-message-id={message.id}
    >
      {!itsMe && (
        <GetUserAvatar
          name={message?.user?.name}
          avatar={message?.user?.avatar_id}
          size={"xsm"}
          className={styles.chatMessage__avatar}
        />
      )}
      <div className={`${styles.chatMessage__block}`} onContextMenu={(e) => contextMenuOpen(e, message)}>
        {!itsMe && message?.user?.name && <div className={`${styles.chatMessage__name}`}>{message.user.name}</div>}
        {message?.reply_id ? (
          <ChatReply message={messages.find((mes) => mes.id === message.reply_id)} />
        ) : message?.reply?.id ? (
          <ChatReply message={messages.find((mes) => mes.id === message.reply?.id)} />
        ) : null}
        <div
          className={`${styles.chatMessage__text}`}
          dangerouslySetInnerHTML={{ __html: cleanHtml(urlify(message.text)) }}
        />
        {/* Изображения */}
        {!!message.photos?.length && (
          <div className={`${styles.chatMessage__images}`}>
            {message.photos?.map((photo: string, index: number) => {
              const info = message.photos_info.find((i) => i.id === photo)
              const width = !info?.width || !info?.height ? undefined : info.height > info.width ? "auto" : info.width
              const height = !info?.width || !info?.height ? undefined : info.width > info.height ? "auto" : info.height
              const ratio = info?.width && info?.height ? `${info.width} / ${info.height}` : undefined

              return (
                <img
                  key={index}
                  onClick={() => openPhoto(message.photos_info, index)}
                  src={getApiUrl() + "/public/photo/" + photo + "?project_id=" + projectID}
                  alt=""
                  width={width}
                  height={height}
                  style={{ aspectRatio: ratio }}
                />
              )
            })}
          </div>
        )}
        {/* Файлы */}
        {/* {!!message.photos?.length &&  */}
        <div className={`${styles.chatMessage__files}`}>
          {message.attachments_info?.map((el: any, kk: number) => {
            return <AttachmentItemChat el={el} key={kk} projectID={projectID} />
          })}
        </div>
        {/* } */}
        <footer className={styles.chatMessage__footer}>
          {message?.updated_at && <span className={styles.chatMessage__changed}>{t("changed")}</span>}
          <span className={`${styles.chatMessage__time}`}>{moment(message.created_at).format("HH:mm")}</span>
        </footer>
      </div>
    </div>
  )
}

export default ChatMessage
